import React from "react";
import { Modal } from "react-bootstrap";
import {
  HiOutlineExclamationCircle,
  HiOutlineShieldCheck,
} from "react-icons/hi";
import useTranslator from "../../hooks/useTranslator";
import LoadingSpinner from "../LoadingSpinner";
import "./SaveAwardedChangesModal.css";

const SaveAwardedChangesModal = ({
  show,
  onHide,
  onConfirm,
  isLoading,
  hasActiveInsurance,
}) => {
  const { _t } = useTranslator();
  const handleHide = () => {
    if (!isLoading) onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleHide}
      centered
      backdrop="static"
      keyboard={!isLoading}
      className="save-awarded-changes-modal"
    >
      <Modal.Body>
        <div className="save-awarded-changes-icon">
          <HiOutlineShieldCheck />
        </div>
        <h2>{_t("saveChangesToRentedProperty")}</h2>
        <p className="save-awarded-changes-description">
          {_t("aboutToChangeTenantsOnAlreadyRentedProperty")}
        </p>
        {hasActiveInsurance && (
          <div className="save-awarded-insurance-warning">
            <HiOutlineExclamationCircle />
            <div>
              <span className="strong-text">
                {_t("propertyAlreadyHasActiveNonPaymentInsurance")}
              </span>{" "}
              <span>{_t("newTenantsRequireManualInsuranceChecks")}</span>
            </div>
          </div>
        )}
        <div className="save-awarded-changes-actions">
          <button
            type="button"
            className="save-awarded-changes-cancel"
            onClick={handleHide}
            disabled={isLoading}
          >
            {_t("cancel")}
          </button>
          <button
            type="button"
            className="save-awarded-changes-confirm"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <LoadingSpinner size="12px" color="#ffffff" borderWidth={2} />
                {_t("saving")}
              </>
            ) : (
              _t("awardProperty")
            )}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SaveAwardedChangesModal;
